import { render, staticRenderFns } from "./userVipPrd.vue?vue&type=template&id=23186081&scoped=true&"
import script from "./userVipPrd.vue?vue&type=script&lang=js&"
export * from "./userVipPrd.vue?vue&type=script&lang=js&"
import style0 from "./userVipPrd.vue?vue&type=style&index=0&id=23186081&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23186081",
  null
  
)

export default component.exports